import { render } from "./SectionUserActivityForm.vue?vue&type=template&id=62783cd0&scoped=true"
import script from "./SectionUserActivityForm.vue?vue&type=script&lang=js"
export * from "./SectionUserActivityForm.vue?vue&type=script&lang=js"

import "./SectionUserActivityForm.vue?vue&type=style&index=0&id=62783cd0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62783cd0"]])

export default __exports__